import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { List } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';

const StoreFacilities = (_param)=>{
    var { className , labels , facilities  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "facilities"
    ]);
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-facilities-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.title), /*#__PURE__*/ React__default.createElement(List, {
        items: facilities,
        icon: "checkmark"
    }));
};
var StoreFacilities$1 = StoreFacilities;

export { StoreFacilities$1 as default };
//# sourceMappingURL=StoreFacilities.js.map
